import Cn from "./Cn";
import En from "./En";
import Th from "./Th";

class Lang
{
    constructor(lang = 'th')
    {
        this.lang = lang;
    }

    get(key, category = 'general')
    {
        const th = new Th();
        const en = new En();
        const cn = new Cn();

        var result = "";

        if(this.lang === 'cn')
        {
            result = cn[category][key];
            if(result === undefined) result = en[category][key];
            if(result === undefined) result = th[category][key];
        }

        if(this.lang === 'en')
        {
            result = en[category][key];
            if(result === undefined) result = th[category][key];
        }

        if(this.lang === 'th')
        {
            result = th[category][key];
            if(result === undefined) result = '{ ' + key + ' }';
        }

        return result;
    }

    link(uri)
    {
        return '/' + this.lang + '/' + uri;
    }

}

export default Lang
